import styles from './TimeInfo.module.scss';
import { useMemo } from 'react';
import Skeleton from 'react-loading-skeleton';
import { useTranslation } from 'react-i18next';
import { useLocaleFormatter } from '@casops/shared/hooks/useLocaleFormatter';
import classNames from 'classnames';

export interface TimeInfoProps {
  label: string;
  timestamp?: string;
  onClick?: () => void;
}

export default function TimeInfo({ label, timestamp, onClick }: TimeInfoProps) {
  const { t } = useTranslation();
  const { parseFromIso, showTimeAndDate } = useLocaleFormatter();
  const isClickable = typeof onClick === 'function';

  const isLoading = timestamp === undefined;

  const ts = useMemo(() => (timestamp ? parseFromIso(timestamp) : null), [parseFromIso, timestamp]);

  return (
    <div className={styles.container}>
      <div className={styles.label}>
        {!isLoading ? label : <Skeleton width="50px" height="16px" />}
      </div>
      {isLoading ? (
        <Skeleton width="120px" height="20px" />
      ) : !ts ? (
        <div id="hoverOpener" className={styles.value}>
          {t('Never')}
        </div>
      ) : (
        <div
          id="hoverOpener"
          className={classNames(styles.value, isClickable && styles.clickable)}
          onClick={onClick}
          role={isClickable ? 'button' : undefined}
        >
          {showTimeAndDate(ts)}
        </div>
      )}
    </div>
  );
}
